var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_271_46)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.872 0.905624H2.13014C1.45393 0.905624 0.905762 1.4538 0.905762 2.13V21.8719C0.905762 22.5481 1.45393 23.0962 2.13014 23.0962H21.872C22.5482 23.0962 23.0964 22.5481 23.0964 21.8719V2.13C23.0964 1.4538 22.5482 0.905624 21.872 0.905624Z",
    fill: "#3D5A98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.215 23.0944V14.5012H19.0987L19.53 11.1525H16.215V9.015C16.215 8.04562 16.485 7.38375 17.8743 7.38375H19.6481V4.38375C18.7892 4.29439 17.926 4.25183 17.0625 4.25625C14.5087 4.25625 12.75 5.8125 12.75 8.68312V11.1525H9.86621V14.5012H12.75V23.0944H16.215Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_271_46"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.fbf07653ede4e147527373faf7a3c72b.svg";
export { ForwardRef as ReactComponent };